import { EntityApiService } from 'modules/common/service';
import { IEmailCampaign } from 'modules/campaigns/interfaces';
import { ApiClientService, RequestConfig } from '@dfl/react-security';
import { CAMPAIGN_STATUS_ENUM } from 'modules/campaigns/constants/common/status.enum';
import { ICurrency } from 'modules/common/constants';

class EmailCampaignService extends EntityApiService<IEmailCampaign | Error> {
  evaluate = (id: string, currency: ICurrency, config?: RequestConfig): Promise<IEmailCampaign> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/${currency}/evaluate`), {}, config));
  };

  updateStatus = (id: string, status: CAMPAIGN_STATUS_ENUM, config?: RequestConfig) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/${status}`), {}, config));
  };
}

export default new EmailCampaignService('/ms-business/api/campaigns');
